// Product analytics for the web app (account.upwex.io). Initialized only when
// REACT_APP_POSTHOG_KEY is set (prod build) — staging (hl.upwex.io,
// .env.development) ships no key so init no-ops and never pollutes prod.
// Events → https://app.upwex.io/e (same-origin proxy → capture, adblock-proof).
// identify(user_id) joins these to backend events (same distinct_id = user id).
// Every function is wrapped so analytics can NEVER break the app render.
import posthog from "posthog-js";
import type { IUser } from "../data-access";

const KEY = process.env.REACT_APP_POSTHOG_KEY || "";
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://app.upwex.io/e";
let inited = false;

export function initPostHog(): void {
  if (inited || !KEY) return;
  try {
    posthog.init(KEY, {
      api_host: HOST,
      ui_host: "https://ph.upwex.io",
      person_profiles: "identified_only",
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: true,
      advanced_disable_feature_flags: true,
      advanced_disable_decide: true,
      disable_external_dependency_loading: true,
      disable_surveys: true,
      disable_session_recording: true,
    });
    inited = true;
  } catch (e) {
    // analytics must never break the app
    // eslint-disable-next-line no-console
    console.warn("posthog init failed", e);
  }
}

export function identifyUser(u?: IUser | null): void {
  if (!inited || !u?.id) return;
  try {
    posthog.identify(u.id, {
      email: u.email,
      name: u.full_name,
      plan: u.plan,
      role: u.role,
      billing_status: u.billing_status,
      paid_user: u.paid_user,
      has_active_subscription: u.has_active_subscription,
      ai_credits_used: u.ai_credits_used,
      ai_credits_total: u.ai_credits_total,
      team_id: u.team_id,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("posthog identify failed", e);
  }
}

export function resetPostHog(): void {
  if (!inited) return;
  try {
    posthog.reset();
  } catch (e) {
    /* noop */
  }
}
